export function getErrorString(error : any) : string {
	if (error == undefined) {
		return "<NULL>";
	}

	if (typeof error === "string") {
		return error;
	}
	else if (typeof error === "boolean") {
		return error.toString();
	}
	else {
		let keys : string[] = Object.getOwnPropertyNames(error);
//		console.trace("Das Objekt hat " + keys.length + " Attribute");
		if (keys.length <= 0)
			return "<NIX>";

		let message : string = "";

		if ('code' in error) {
			message = "Code: '" + error['code'] + "'";
			if (keys.includes('code'))
				keys.splice(keys.indexOf('code'), 1);
		}

		if ('message' in error) {
			if (message.length > 0)
				message += ", ";
			message += "Message: '" + error['message'] + "'";
			if (keys.includes('message'))
				keys.splice(keys.indexOf('message'), 1);
		}

		if ('stack' in error) {
			if (message.length > 0)
				message += "\n";
			message += "Stack:\n" + error['stack'] + "'";
			if (keys.includes('stack'))
				keys.splice(keys.indexOf('stack'), 1);
		}

		for (const key of keys) {
			if (message.length > 0)
				message += "\n";
			message += key + ": " + error[key] + "'";
		}


		// Wenn am Ende immer noch nix aus dem error herausgelutscht wurde, dann eben den error ansich
		if (message.length == 0)
			message = error.toString();

		return message;
	}
}


// WEBPACK FOOTER //
// ./src/visionet/Error.ts